import { useCallback } from 'react';
import { Extra, useApiContext } from '@omnipkg/ui-kit-web';

interface PlaceParcelRequest {
  device_uid: string;
  order_uid: string;
  ignore_open_cells?: boolean;
}

interface PlaceParcelArgs {
  deviceUid: string;
  orderUid: string;
  ignoreOpenCells?: boolean;
}

export function usePlaceParcel() {
  const { request } = useApiContext();

  return useCallback(
    async ({
      deviceUid,
      orderUid,
      ignoreOpenCells,
    }: PlaceParcelArgs): Promise<Extra | undefined> => {
      const { extra } = await request<never, PlaceParcelRequest>({
        url: '/order/placing/web/',
        method: 'POST',
        data: {
          device_uid: deviceUid,
          order_uid: orderUid,
          ignore_open_cells: ignoreOpenCells,
        },
      });

      return extra;
    },
    [request],
  );
}
